import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "dt-mainCard__head-navBack" }
const _hoisted_3 = { class: "dt-mainCard__head-content" }
const _hoisted_4 = { class: "dt-mainCard__head-content-defaultColumn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_element = _resolveComponent("header-element")!
  const _component_map_column = _resolveComponent("map-column")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dt-mainCard__head", {'dt-mainCard__head_twoColumn': !this.header.mapColumn}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($props.goBack && $props.goBack(...args))),
          class: "block-btnNavBack"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["dt-mainCard__head-content-imageColumn", {'wide': this.header.imageColumn.style.viewMode === 'wide'}])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.header.imageColumn.elements, (element) => {
            return (_openBlock(), _createBlock(_component_header_element, {
              element: element,
              "name-column": 'image'
            }, null, 8 /* PROPS */, ["element"]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.header.defaultColumn.elements, (element) => {
            return (_openBlock(), _createBlock(_component_header_element, {
              element: element,
              onApplyFilter: $options.onApplyFilter
            }, null, 8 /* PROPS */, ["element", "onApplyFilter"]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ])
      ])
    ]),
    (this.header.mapColumn)
      ? (_openBlock(), _createBlock(_component_map_column, {
          key: 0,
          "map-column": this.header.mapColumn
        }, null, 8 /* PROPS */, ["map-column"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}